import {
  BadRequest,
  InternalError,
  NetworkError,
  ServiceUnavailable,
} from 'common/errors'
import { optInFail } from 'publisher/actions/optInActions'
import { BuyUpsellBody, buyUpsell } from 'publisher/api/paypalRestApi'
import useUpsellSubmit from 'publisher/pages/UpsellPage/hooks/useUpsellSubmit'
import { PurchaseProcessId } from 'publisher/store/payment/PaymentStateInterface'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { UpsellButtonEntityInterface } from 'src/shared/entities/upsell-button/upsell-button.schema'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

export const usePaypalUpsellRestHandler = (
  entity: UpsellButtonEntityInterface,
) => {
  const dispatch = useDispatch()
  const { t } = useTypedTranslation()
  const { errors, setErrors, isLoading, submit } = useUpsellSubmit(entity)
  const [orderHash, setOrderHash] = useState('')
  const [isUpsellLoading, setIsUpsellLoading] = useState(false)

  const handleSubmit = async () => {
    return await submit(
      async (
        body: BuyUpsellBody,
        pageId: number,
        purchaseProcessId: PurchaseProcessId,
      ) => {
        try {
          setIsUpsellLoading(true)
          const { data } = await buyUpsell({
            pageId,
            purchaseProcessId,
            body,
          })
          setOrderHash(data.options.hash)
          if (data.options.paypalOrderId) {
            return data.options.paypalOrderId
          }
          return data.options.paypalSubscriptionId
        } catch (error) {
          if (error instanceof BadRequest) {
            setErrors(error.response.data.errors.common)
            dispatch(optInFail({ fields: error.response.data.errors.fields }))
          } else if (error instanceof ServiceUnavailable) {
            setErrors([t('core.errors.service_temporary_unavailable')])
          } else if (error instanceof NetworkError) {
            setErrors([t('core.errors.no_connection')])
          } else if (error instanceof InternalError) {
            setErrors([t('core.error.title')])
          }
        }
      },
    )
  }

  return {
    errors,
    isLoading: isLoading || isUpsellLoading,
    handleSubmit,
    orderHash,
  }
}
